import { cn } from '@/lib/utils';

function splitTitle(title) {
  const words = String(title || '').trim().split(/\s+/u).filter(Boolean);
  if (words.length <= 1) {
    return { base: '', highlight: words[0] || title };
  }

  return {
    base: words.slice(0, -1).join(' '),
    highlight: words[words.length - 1],
  };
}

export default function PageShowcaseTitle({
  as: HeadingTag = 'h1',
  className,
  subtitle,
  subtitleClassName,
  title,
  titleClassName,
}) {
  const { base, highlight } = splitTitle(title);
  const titleLabel = String(title || '');
  const titleContent = (
    <>
      {base ? <span className="landing-section-title-base">{base}</span> : null}
      <span className="landing-section-title-highlight">{highlight}</span>
    </>
  );

  return (
    <div className={cn('landing-section-heading', className)}>
      <div aria-hidden="true" className="landing-section-title-rail">
        <span />
        <span className="landing-section-title-marker" />
        <span />
      </div>
      {HeadingTag === 'h1' ? (
        <h1
          aria-label={titleLabel}
          className={cn('landing-section-title-text', titleClassName)}
        >
          {titleContent}
        </h1>
      ) : (
        <HeadingTag
          aria-label={titleLabel}
          className={cn('landing-section-title-text', titleClassName)}
        >
          {titleContent}
        </HeadingTag>
      )}
      <span aria-hidden="true" className="landing-section-title-accent" />
      {subtitle ? (
        <p className={cn('page-showcase-title-subtitle', subtitleClassName)}>
          {subtitle}
        </p>
      ) : null}
    </div>
  );
}
